import React from "react";
import { XYChartContextValue } from "./XYChart.types";

const XYChartContext = React.createContext<
  XYChartContextValue<unknown> | undefined
>(undefined);

export function useXYChartView<T>() {
  return React.useContext<XYChartContextValue<T>>(
    XYChartContext as React.Context<XYChartContextValue<T>>
  );
}

export const XYChartProvider = XYChartContext.Provider;
